"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const supportsLocalStorage = () => {
    try {
        const data = 'TEST_VALUE_TEST_VALUE_TEST_VALUE_TEST_VALUE';
        localStorage.setItem(data, data);
        localStorage.removeItem(data);
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.default = supportsLocalStorage;
//# sourceMappingURL=supportsLocalStorage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/supportsLocalStorage.js
// module id = h1ky
// module chunks = 56